import { typeMetaEnum, EnumMetaType } from "@/autogen/common";
import { PurchasableState } from "./PurchasableState";

export type PurchasableStateMetaI = EnumMetaType<typeof PurchasableState, PurchasableState>;
export const PurchasableStateMeta = typeMetaEnum<typeof PurchasableState, PurchasableState>("PurchasableState", PurchasableState);

